import * as React from "react";
import { connect } from "react-redux";
import * as router from "react-router-redux";

import * as tokens from "../modules/user/actions";
import * as notifications from "../modules/notifications/actions";
import ForgotPasswordForm from "../components/ForgotPasswordForm";

class ForgotPasswordContainer extends React.PureComponent {
    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit(email) {
        this.props
            .requestPasswordReset(email)
            .then(() =>
                this.props.navigateTo({
                    pathname: "/login",
                    state: {
                        initialEmail: email
                    }
                })
            )
            .then(() =>
                this.props.notifySuccess(
                    "A password reset email is headed your way."
                )
            );
    }

    render() {
        return (
            <main>
                <ForgotPasswordForm onSubmit={this.handleSubmit} />
            </main>
        );
    }
}

function mapStateToProps() {
    return {};
}

function mapDispatchToProps(dispatch) {
    return {
        navigateTo: url => dispatch(router.push(url)),
        notifySuccess: (message, icon, button) =>
            dispatch(notifications.notifySuccess(message, icon, button)),
        requestPasswordReset: email =>
            dispatch(tokens.requestPasswordReset(email))
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ForgotPasswordContainer);



// WEBPACK FOOTER //
// ./src/containers/ForgotPasswordContainer.js